import type { CityConfig } from "@/pages/city-template/types";

export const ballstonSpaConfig: CityConfig = {
  city: "Ballston Spa",
  state: "New York",
  stateAbbr: "NY",
  slug: "ballston-spa",
  route: "/cities/ballston-spa",
  title: "Emergency & Expedited Passport Ballston Spa NY | Same Day Passport Ballston Spa",
  metaDescription:
    "Emergency passport Ballston Spa NY — same day, 24-hour, and 3-5 day expedited passport processing for Saratoga County. Fast Passport Center serves Ballston Spa, Malta, Clifton Park, and all Capital Region communities.",
  h1: "Emergency & Expedited Passport Services in Ballston Spa, NY",
  heroSubtitle:
    "Ballston Spa's fast passport solution — Saratoga County's historic village. Whether you're flying out of Albany International for business or a European getaway, Fast Passport Center delivers emergency passports in as little as 24 hours and expedited processing in 3-5 days.",
  heroImageUrl:
    "https://readdy.ai/api/search-image?query=Historic%20Ballston%20Spa%20village%20in%20New%20York%20Saratoga%20County%20with%20charming%20Victorian%20architecture%20and%20historic%20downtown%2C%20tree-lined%20Main%20Street%20with%20small-town%20American%20atmosphere%2C%20warm%20golden%20afternoon%20light%2C%20modern%20travel%20photography%20with%20clean%20composition%2C%20no%20text%20overlay%2C%20picturesque%20upstate%20New%20York%20historic%20village%20scene%20with%20Capital%20Region%20charm&width=1600&height=700&seq=ny-ballston-spa-hero-001&orientation=landscape",
  heroImageAlt: "Historic Ballston Spa village in Saratoga County with Victorian architecture and tree-lined Main Street",
  geoPosition: "43.0009; -73.8490",
  geoPlacename: "Ballston Spa, New York, United States",
  lastModified: "2026-05-31",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~170 miles (Southeast in Manhattan)",
  },
  nearbyCitiesZips: [
    { name: "Ballston Spa", zips: "12020" },
    { name: "Saratoga Springs", zips: "12866, 12871" },
    { name: "Malta", zips: "12020" },
    { name: "Clifton Park", zips: "12065" },
    { name: "Mechanicville", zips: "12118" },
    { name: "Round Lake", zips: "12151" },
    { name: "Burnt Hills", zips: "12027" },
    { name: "Charlton", zips: "12019" },
    { name: "Galway", zips: "12074" },
    { name: "Providence", zips: "12850" },
    { name: "Milton", zips: "12020" },
    { name: "Greenfield", zips: "12833" },
    { name: "Troy", zips: "12180, 12181, 12182, 12183" },
    { name: "Schenectady", zips: "12301-12309, 12325, 12345" },
    { name: "Albany", zips: "12201-12212, 12214, 12220, 12222-12226, 12228, 12230-12232, 12233, 12234, 12235, 12236, 12237, 12238, 12239, 12240, 12241, 12242, 12243, 12244, 12245, 12246, 12247, 12248, 12249, 12250, 12252, 12255, 12256, 12257, 12260, 12261, 12262, 12288" },
    { name: "Glens Falls", zips: "12801" },
    { name: "Queensbury", zips: "12804" },
    { name: "Lake George", zips: "12845" },
  ],
  benefits: [
    {
      icon: "ri-time-line",
      title: "As Fast as 24 Hours",
      desc: "Emergency passport processing for Ballston Spa travelers with urgent departures — same day service available for documented emergencies.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Registered Courier",
      desc: "U.S. Department of State registered passport courier with direct access to the New York Passport Agency.",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "Real Human Support",
      desc: "Dedicated agents guide you through every step — no chatbots, no automated runaround. Available for Ballston Spa residents 7 days a week.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Saratoga County & Capital Region",
      desc: "Ballston Spa, Saratoga Springs, Malta, Clifton Park, and all of Saratoga County — we serve the entire Capital Region with fast, reliable passport processing.",
    },
  ],
  testimonials: [
    {
      name: "Patricia K.",
      location: "Ballston Spa, NY",
      rating: 5,
      text: "Needed my passport renewed for a business trip to Toronto in 4 days. Fast Passport Center delivered in 3 days. The service was seamless from right here in Ballston Spa.",
      service: "Passport Renewal",
    },
    {
      name: "James R.",
      location: "Malta, NY",
      rating: 5,
      text: "First-time passport for our family trip to the Caribbean. The agent helped us through the Ballston Spa post office process. Everything arrived in 5 days. Couldn't be happier.",
      service: "New Passport",
    },
    {
      name: "Linda C.",
      location: "Clifton Park, NY",
      rating: 5,
      text: "Emergency passport renewal for a last-minute European conference. Fast Passport Center handled everything while I was working. The 3-day service was perfect for a busy professional.",
      service: "Expedited Passport",
    },
  ],
  facilities: [
    {
      id: "ballston-spa-1",
      name: "Ballston Spa Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "100 Washington Street",
      city: "Ballston Spa",
      state: "NY",
      zip: "12020",
      phone: "518-885-6431",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Downtown Ballston Spa",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Main Ballston Spa passport acceptance facility. First-time applicants and those not eligible for mail-in renewal must apply in person.",
      icon: "ri-building-2-line",
    },
    {
      id: "ballston-spa-2",
      name: "Saratoga Springs Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "475 Broadway",
      city: "Saratoga Springs",
      state: "NY",
      zip: "12866",
      phone: "518-587-0341",
      hours: "Mon-Fri 8:30 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Saratoga Springs (~6 miles north)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available by appointment. Convenient for Saratoga Springs, Malta, and northern Saratoga County residents.",
      icon: "ri-building-2-line",
    },
    {
      id: "ballston-spa-3",
      name: "Malta Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "2451 Route 9",
      city: "Malta",
      state: "NY",
      zip: "12020",
      phone: "518-899-2891",
      hours: "Mon-Fri 9:00 AM - 4:30 PM",
      distance: "Malta (~4 miles east)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available. Serving Malta, Round Lake, and eastern Saratoga County communities.",
      icon: "ri-building-2-line",
    },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Ballston Spa?",
      a: "Fast Passport Center offers same-day emergency passport processing in as little as 24 hours for Ballston Spa residents with documented life-or-death emergencies. For urgent travel within 2 weeks, our 3-5 day expedited service is the most popular option. Standard processing through the post office takes 8-11 weeks.",
    },
    {
      q: "Where is the closest passport acceptance facility in Ballston Spa?",
      a: "The Ballston Spa Post Office at 100 Washington Street is the main Ballston Spa passport acceptance facility. The Saratoga Springs Post Office at 475 Broadway and Malta Post Office at 2451 Route 9 are also convenient options for Saratoga County residents.",
    },
    {
      q: "Can I get same-day passport photos in Ballston Spa?",
      a: "Yes — passport photos are available at CVS Pharmacy, Walgreens, and Rite Aid locations in Ballston Spa, Saratoga Springs, and Clifton Park. We also offer photo review as part of our service to ensure your 2x2 photos meet all State Department requirements.",
    },
    {
      q: "How much does an expedited passport cost in Ballston Spa?",
      a: "Government fees are set by the State Department and vary based on passport type (book vs card, large book option). Fast Passport Center's service fees depend on processing speed: 10-day Smart Saver, 3-5 day Expedited, or 24-hour Emergency. Call 877-253-0084 for a personalized quote based on your Ballston Spa passport needs.",
    },
    {
      q: "Do I need to visit the New York Passport Agency in person?",
      a: "No — if you use Fast Passport Center, you do not need to visit the New York Passport Agency in Manhattan. As a registered courier, we handle the agency submission for you. The only reason to visit the agency directly is for a documented life-or-death emergency, and appointments are extremely difficult to obtain.",
    },
    {
      q: "What is the fastest way to renew a passport in Ballston Spa?",
      a: "The fastest way to renew a passport in Ballston Spa is through Fast Passport Center's 3-5 day expedited service. If your most recent passport was issued when you were 16 or older, within the last 15 years, and is undamaged, you may qualify for renewal without an acceptance clerk visit. For even faster renewal, our 24-hour emergency service is available.",
    },
    {
      q: "Can I get a child passport expedited in Ballston Spa?",
      a: "Yes — Fast Passport Center expedites child passports for minors under 16 in Ballston Spa and all Saratoga County communities. Both parents must appear with the child or provide notarized consent (Form DS-3053). We review all parental consent documentation before submission to avoid delays.",
    },
    {
      q: "Does Fast Passport Center have an office in Ballston Spa?",
      a: "Fast Passport Center operates as a remote courier service — we do not have a physical office in Ballston Spa. We serve Saratoga County and the Capital Region through our secure overnight shipping and agency submission process. Our headquarters are in Washington, DC.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Ballston Spa", address: "various CVS locations in Ballston Spa, Saratoga Springs, and Clifton Park", hours: "Mon-Sun, hours vary by location" },
    { name: "Walgreens — Saratoga Springs", address: "various Walgreens locations in Saratoga Springs and Clifton Park", hours: "Mon-Sun, hours vary by location" },
    { name: "Rite Aid — Ballston Spa", address: "Rite Aid locations in Ballston Spa and nearby Saratoga County towns", hours: "Mon-Sun, hours vary by location" },
    { name: "Walmart Photo Center — Saratoga Springs", address: "Walmart Supercenter, Saratoga Springs", hours: "Mon-Sun 8:00 AM - 10:00 PM" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Ballston Spa",
      address: "3 Office Park Drive, Ballston Spa, NY 12020",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Ballston Spa DMV office for license renewals and REAL ID applications. Serves Ballston Spa, Malta, and Saratoga County.",
      featured: true,
    },
    {
      name: "NYS DMV — Saratoga Springs",
      address: "6 Franklin Square, Saratoga Springs, NY 12866",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Saratoga Springs DMV office serving northern Saratoga County and nearby communities.",
      featured: false,
    },
    {
      name: "NYS DMV — Clifton Park",
      address: "21 Conservation Way, Clifton Park, NY 12065",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Clifton Park DMV office serving southern Saratoga County and northern Albany County residents.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "ALB",
      name: "Albany International Airport",
      distance: "~35 miles from Ballston Spa",
      address: "737 Albany Shaker Road, Albany, NY 12211",
      note: "The closest major airport to Ballston Spa with flights to destinations nationwide and international connections. Most convenient for Saratoga County travelers.",
      flightUrl: "https://www.albanyairport.com/",
      flightLabel: "Albany Airport",
      featured: true,
    },
    {
      code: "KGFL",
      name: "Saratoga County Airport",
      distance: "~10 miles from Ballston Spa",
      address: "21 West Milton Road, Ballston Spa, NY 12020",
      note: "General aviation airport serving Saratoga County and the Capital Region. For private and charter flights.",
      flightUrl: "https://www.saratogacountyairport.com/",
      flightLabel: "Saratoga Airport",
      featured: false,
    },
    {
      code: "5B2",
      name: "Floyd Bennett Memorial Airport (Glens Falls)",
      distance: "~30 miles from Ballston Spa",
      address: "443 Queensbury Avenue, Queensbury, NY 12804",
      note: "General aviation airport serving Glens Falls and the Adirondack region. For private and charter flights.",
      flightUrl: "https://www.glensfallsairport.com/",
      flightLabel: "Glens Falls Airport",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-passport-line",
      title: "Emergency Passport",
      description: "For Ballston Spa travelers with urgent departures within 24 hours to 2 weeks. Direct New York Passport Agency submission with dedicated courier handling.",
      bullets: ["Processing as fast as 24 hours", "Dedicated agent assigned to your case", "Daily status updates"],
      badge: "Fastest",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Fast renewal for Ballston Spa residents with a valid passport issued within the last 15 years at age 16 or older.",
      bullets: ["3-5 day or 10-day options available", "No acceptance clerk visit required", "Secure overnight document return"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-user-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for Ballston Spa residents with step-by-step guidance through the acceptance clerk process.",
      bullets: ["Complete application review before submission", "Acceptance clerk appointment guidance", "3-5 day or 10-day processing options"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alarm-warning-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement service for Ballston Spa residents who have lost their passport or had it stolen.",
      bullets: ["DS-64 form guidance included", "Replacement in 3-5 days or 10 days", "Acceptance clerk visit required"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 in Ballston Spa, with parental consent guidance and acceptance clerk support.",
      bullets: ["Parental consent documentation review", "Both parents present or notarized consent", "3-5 day or 10-day processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal name change for Ballston Spa residents.",
      bullets: ["Marriage certificate or court order review", "Name change in 3-5 days or 10 days", "No clerk visit for most renewals"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Ballston Spa travelers with immediate departure needs from Albany International or Saratoga County Airport." },
    { name: "Passport Renewal", description: "Fast passport renewal for Ballston Spa residents with a recent valid passport." },
    { name: "New Passport", description: "First-time passport application assistance for Ballston Spa residents." },
    { name: "Lost or Stolen Passport", description: "Passport replacement for Ballston Spa residents who have lost their passport." },
    { name: "Child Passport", description: "Passport services for minors under 16 in Ballston Spa and Saratoga County." },
    { name: "Name Change", description: "Passport name change service after marriage, divorce, or legal name change in Ballston Spa." },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Photos must be 2\"x2\" with a plain white or off-white background. Many Ballston Spa travelers get rejected at the acceptance clerk because their photos don't meet strict State Department specs.",
    },
    {
      icon: "ri-file-list-3-line",
      title: "Missing or Incorrect Forms",
      description: "Using the wrong form (DS-11 vs DS-82) or missing required fields can cause weeks of delays. We review every form before submission.",
    },
    {
      icon: "ri-calendar-line",
      title: "Waiting Too Long to Start",
      description: "Standard processing takes 8-11 weeks. Many Ballston Spa travelers wait until the last minute, leaving no buffer for problems.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Incorrect Payment Amount",
      description: "Government fees change frequently. Using an outdated check or wrong amount will cause your application to be returned.",
    },
    {
      icon: "ri-shield-line",
      title: "Damaged or Expired ID",
      description: "Your driver's license or state ID must be valid and unexpired. Many applicants don't realize their ID is about to expire until it's too late.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For child passports, both parents must appear or provide notarized consent. Missing documentation is the #1 reason child applications are delayed.",
    },
  ],
  steps: [
    {
      number: "01",
      icon: "ri-file-list-3-line",
      title: "Complete Your Application",
      description: "Fill out your passport application online or over the phone with our Ballston Spa team. We review everything for accuracy.",
    },
    {
      number: "02",
      icon: "ri-upload-cloud-line",
      title: "Send Us Your Documents",
      description: "Ship your documents via overnight courier to our secure processing center. We confirm receipt and begin review immediately.",
    },
    {
      number: "03",
      icon: "ri-search-line",
      title: "We Review Everything",
      description: "Our agents verify your forms, photos, and supporting documents meet all State Department requirements — no surprises.",
    },
    {
      number: "04",
      icon: "ri-shield-check-line",
      title: "Courier Submission",
      description: "As a registered U.S. Department of State courier, we submit your application directly to the New York Passport Agency.",
    },
    {
      number: "05",
      icon: "ri-passport-line",
      title: "Receive Your Passport",
      description: "Your passport is delivered securely to your Ballston Spa address. We provide tracking and daily status updates throughout.",
    },
  ],
  processingOptions: [
    {
      speed: "8-11",
      unit: "weeks",
      label: "Standard Processing",
      tag: "Post Office",
      tagColor: "bg-gray-200 text-gray-600",
      features: [
        "Mail-in application",
        "No expedited handling",
        "No dedicated agent",
        "No phone or email contact for your case",
        "Updates only by physical mail letter",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "10",
      unit: "business days",
      label: "Smart Saver",
      tag: "Fast Passport Center",
      tagColor: "bg-green-100 text-green-700",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned",
        "Daily status updates",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "3-5",
      unit: "business days",
      label: "Expedited Processing",
      tag: "Recommended",
      tagColor: "bg-[#1A365D] text-white",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "24",
      unit: "hours",
      label: "Emergency Processing",
      tag: "Life or Death",
      tagColor: "bg-red-100 text-red-600",
      features: [
        "For documented life-or-death emergencies only",
        "Requires proof of emergency travel",
        "Strictly for documented life-or-death emergencies",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Must book weeks in advance", fpc: "No appointment needed — we handle agency access" },
    { feature: "Processing Speed", agency: "1-2 business days (if you get an appointment)", fpc: "As fast as 3-5 days or 24 hours for emergencies" },
    { feature: "Document Review", agency: "No pre-check — one mistake means restart", fpc: "Complete review before submission — we catch errors" },
    { feature: "Travel Proof", agency: "Requires printed itinerary with confirmed travel within 2 weeks", fpc: "Flexible documentation requirements" },
    { feature: "Updates", agency: "No phone or email support — only mail updates", fpc: "Daily status updates via phone and email" },
    { feature: "Guarantee", agency: "No guarantee of appointment or same-day processing", fpc: "Reserved agency slots with predictable processing" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "New York City", route: "/cities/new-york-city" },
    { name: "Brooklyn", route: "/cities/brooklyn" },
    { name: "Queens", route: "/cities/queens" },
    { name: "Buffalo", route: "/cities/buffalo" },
    { name: "Albany", route: "/cities/albany-ny" },
    { name: "Rochester", route: "/cities/rochester" },
    { name: "Syracuse", route: "/cities/syracuse" },
    { name: "Yonkers", route: "/cities/yonkers" },
    { name: "Utica", route: "/cities/utica" },
    { name: "Schenectady", route: "/cities/schenectady" },
    { name: "Troy", route: "/cities/troy" },
    { name: "Saratoga Springs", route: "/cities/saratoga-springs" },
    { name: "Elmira", route: "/cities/elmira" },
    { name: "Ithaca", route: "/cities/ithaca" },
    { name: "Corning", route: "/cities/corning" },
    { name: "Jamestown", route: "/cities/jamestown" },
    { name: "Plattsburgh", route: "/cities/plattsburgh" },
    { name: "Watertown", route: "/cities/watertown" },
    { name: "Ogdensburg", route: "/cities/ogdensburg" },
    { name: "Glens Falls", route: "/cities/glens-falls" },
    { name: "Lake George", route: "/cities/lake-george" },
    { name: "Kingston", route: "/cities/kingston" },
    { name: "Middletown", route: "/cities/middletown-ny" },
    { name: "New Paltz", route: "/cities/new-paltz" },
    { name: "Poughkeepsie", route: "/cities/poughkeepsie" },
    { name: "Newburgh", route: "/cities/newburgh" },
    { name: "Beacon", route: "/cities/beacon" },
    { name: "Fishkill", route: "/cities/fishkill" },
    { name: "Mount Vernon", route: "/cities/mount-vernon" },
    { name: "Tarrytown", route: "/cities/tarrytown" },
    { name: "Hyde Park", route: "/cities/hyde-park" },
    { name: "Red Hook", route: "/cities/red-hook" },
    { name: "Rhinebeck", route: "/cities/rhinebeck" },
    { name: "Hudson", route: "/cities/hudson-ny" },
    { name: "Catskill", route: "/cities/catskill" },
    { name: "New York State", route: "/states/new-york" },
  ],
  fpcOfficeNote:
    "Fast Passport Center serves Ballston Spa and Saratoga County as a remote courier service. We do not have a physical office in Ballston Spa, but our secure overnight shipping network ensures your documents reach our processing center quickly and safely.",
  fpcOfficeDistance: "Remote courier service — Ballston Spa area",
  serviceAreaIntro:
    "Fast Passport Center provides expedited passport services to Ballston Spa and all of Saratoga County. From Saratoga Springs to Clifton Park, from Malta to Mechanicville — we serve the entire Capital Region with the same fast, reliable processing.",
  nearbyCitiesIntro:
    "We proudly serve Ballston Spa and all surrounding communities across Saratoga County and the Capital Region. Whether you're in Saratoga Springs, Malta, or Clifton Park, our expedited passport services are available to you.",
  howItWorksIntro:
    "Our Ballston Spa customers follow a simple, proven process to get their passports fast. No agency visits, no waiting in lines, no guessing.",
  mistakesIntro:
    "These are the most common mistakes Ballston Spa travelers make when applying for an expedited passport. Avoiding them saves weeks of delays.",
  testimonialsIntro:
    "Ballston Spa travelers trust Fast Passport Center for their urgent passport needs. Here's what they say about our service.",
  faqIntro:
    "Common questions about emergency and expedited passport services in Ballston Spa. If you don't see your question here, call us at 877-253-0084.",
  statePageRoute: "/states/new-york",
  statePageName: "New York Passport Services",
};

export default ballstonSpaConfig;